// src/i18n/en/channelsAnalytics.ts
// «Canales» (mockup 06) — route /channels, Dirección.
export const channelsAnalytics = {
  name: 'Channels |||| Channels',
  subtitle: 'How arrivals split across channels and where they stop',

  table: {
    title: 'By channel',
    dispenserKeyOnly: 'Dispenser (key only)',
    description:
      'Each journey counts on the channel where its check-in was completed; if not completed yet, on the last channel it moved to; «Dispenser (key only)» are the journeys that ended collecting the key at the dispenser without a check-in. Channel switches are shown separately. The session is the pre-check-in itself for Online and, on the other channels, from the start of the check-in to its completion (key delivery not included); the median and the 2 and 5 minute cuts measure that same session. With fewer than 20 cases the figure is not shown.',
    columns: {
      channel: 'Channel',
      journeys: 'Journeys',
      completionRate: '% completed',
      medianTotalMinutes: 'Median session duration',
      under2MinPct: '< 2 min',
      under5MinPct: '< 5 min',
      retried: 'Retried',
    },
  },

  keys: {
    title: 'Key delivery',
    description:
      'Journeys of the period with a key delivered at the kiosk or the dispenser, by key type («No type» when the device does not report it). «Failed»: journeys with a delivery error there and no key delivered. The dispenser only issues cards.',
    columns: {
      where: 'Source',
      delivered: 'Delivered',
      card: 'Card',
      digital: 'Digital',
      unknown: 'No type',
      failed: 'Failed',
    },
    whereKiosk: 'Kiosk',
    whereDispenser: 'Dispenser',
  },

  stops: {
    title: 'Where they stop',
    description:
      'Each section counts on the channel it was shown on. «Reached»: journeys of the period that entered the section; «Stopped»: those that abandoned it there. Below, the median time in the section (entry to exit). The percentage needs at least 20 journeys and the time at least 20 visits with an entry and an exit.',
    insufficient: 'insufficient sample',
    median: 'median %{time}',
    medianInsufficient: 'median: insufficient sample (n = %{count})',
    columns: {
      section: 'Section',
      reached: 'Reached',
      stopped: 'Stopped',
      pct: '%',
      medianSeconds: 'Median time',
    },
  },

  transitions: {
    title: 'Channel switches',
    fromPartial: '%{channel} · half done',
    columns: {
      from: 'From',
      to: 'To',
      journeys: 'Reservations',
      complete: 'Completed',
    },
  },

  chart: {
    title: 'Split by channel',
  },

  filters: {
    channel: 'Channel',
  },

  axis: {
    arrival: 'Arrival date',
    activity: 'Activity date',
  },

  help: {
    title: 'Channels',
    description: 'How guests reach each channel, how long it takes, and which section they stop in most often.',
    features: {
      table: 'The by-channel table compares volume, duration and retries. «Retried» is only measured for Online: guests who reopened the pre-check-in after an attempt left half done, before finishing it; «—» on the other channels.',
      stops: '"Where they stop" shows which section each channel drops off in.',
      sample: 'Percentages, medians and time cuts need at least 20 cases; below that you will see «Insufficient sample» with the number of cases.',
    },
    tips: {
      channel: 'Use the «Channel» filter to see only the channels you need, for example Pre-check-in online.',
      axis: 'The default axis is the arrival date; with activity date, each journey counts on the (hotel) day it started. Every block of the screen uses the same journeys.',
    },
  },
};

export default channelsAnalytics;
